import * as THREE from 'three'

export abstract class ThreeColors {
  static selectedColor = new THREE.Color(0xB8F444)
  static hoverColor = new THREE.Color(0xBABABA)
  static defaultColor = new THREE.Color()
}
